module.exports = __webpack_public_path__ + "static/media/iv_no_rewards.4756b937.svg";